import http from "../../../../services/httpService";
import { ResumeSearchResponse } from "../interfaces/LearnerInterfaces";

const LearnerClient = {
  list: async (params?: {
    page_number?: number;
    limit?: number;
    name?: string;
    email?: string;
    education?: string;
    skills?: string;
    job_categories?: string;
    status?: string;
  }) => {
    const response = await http.get("/interview_admin/users", { params });
    return response.data;
  },

  get: async (email: string) => {
    const response = await http.get(`/interview_admin/users/${encodeURIComponent(email)}`);
    return response.data;
  },

  update: async (email: string, data: any) => {
    const response = await http.post(`/interview_admin/users/${encodeURIComponent(email)}`, data);
    return response.data;
  },

  delete: async (email: string) => {
    const response = await http.delete(`/interview_admin/users/${encodeURIComponent(email)}`);
    return response.data;
  },

  bulkDeleteUsers: async (emails: string[]) => {
    const response = await http.delete("/interview_admin/users/bulk/delete", {
      data: { users: emails }
    });
    return response.data;
  },

  upload: async (formData: FormData) => {
    const response = await http.post("/interview_admin/upload_users", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  uploadTrack: async (params?: {
    page_number?: number;
    limit?: number;
    file_name?: string;
    status?: string;
  }) => {
    const response = await http.get("/interview_admin/upload_users/track", { params });
    return response.data;
  },

  uploadView: async (params: {
    file_id: string;
    page_number?: number;
    limit?: number;
    name?: string;
  }) => {
    const response = await http.get("/interview_admin/upload_users/status_view", { params });
    return response.data;
  },

  downloadTemplate: async (fileType: string) => {
    const response = await http.get("/interview_admin/upload_users/template", {
      params: { file_type: fileType },
    });
    return response;
  },

  createUploadUrl: async (filename: string) => {
    const response = await http.get("/create_upload_url", {
      params: { filename },
    });
    return response.data;
  },

  addMultipleLearners: async (data: any[]) => {
    const response = await http.post("/interview_admin/user/add_multiple", { "learners": data });
    return response.data;
  },

  exportUsers: async (payload: { file_type: string; export_all?: boolean; candidates?: string[] }) => {
    const response = await http.post("/interview_admin/user/export", { "users": payload.candidates }, {
      params: {
        file_type: payload.file_type,
        export_all: payload.export_all || false,
      },
    });
    return response.data;
  },

  searchResumes: async (jobDescription: string): Promise<ResumeSearchResponse> => {
    const response = await http.post<ResumeSearchResponse>("/interview_admin/resumes/search", {
      job_description: jobDescription,
      generate_summary: true,
      top_k: 20,
    });
    return response.data;
  },

  // ── Bulk Resume Upload ──
  uploadResumes: async (formData: FormData) => {
    const response = await http.post("/interview_admin/upload_resumes", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  resumeUploadTrack: async (params?: {
    page_number?: number;
    limit?: number;
    file_name?: string;
    status?: string;
  }) => {
    const response = await http.get("/interview_admin/upload_resumes/track", { params });
    return response.data;
  },

  resumeUploadStatus: async (file_id: string) => {
    const response = await http.get(`/interview_admin/upload_resumes/${file_id}/status`);
    return response.data;
  },

  approveUsers: async (users: string[]) => {
    const response = await http.post("/interview_admin/applicant/approve", {
      users,
    });
    return response.data;
  },

  bulkOnboardUsers: async (users: string[]) => {
    const response = await http.post("/interview_admin/users/bulk/onboard", {
      users,
    });
    return response.data;
  },

  onboard: async (email: string) => {
    const response = await http.post(`/interview_admin/users/${encodeURIComponent(email)}/onboard`);
    return response.data;
  },
};

export default LearnerClient;
